<template>
  <div
    id="notification_toast"
    :class="`toast toast-position tw-pointer-events-none ${show ? 'show' : ''}`"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
const show = ref(false);
import { Toast } from "bootstrap";

const props = defineProps({
  countDown: {
    type: Number,
    default: 750,
  },
});

/**
 * Use: handleShow()
 * Call this function from the parent component through "ref".
 */
const handleShow = () => {
  if (show.value) return;

  const notificationToast = document.getElementById("notification_toast");
  if (!notificationToast) return;

  // Create a Bootstrap Toast instance
  const toastInstance = new Toast(notificationToast, {
    delay: props.countDown,
  });

  // Show the toast
  toastInstance.show();
  show.value = true;

  // Add an event listener for the 'hidden.bs.toast' event
  notificationToast.addEventListener("hidden.bs.toast", () => {
    show.value = false;
    toastInstance.hide();
  });
};

defineExpose({
  handleShow,
});
</script>

<style lang="scss" scoped>
#notification_toast {
  max-width: unset;
}

.toast-position {
  z-index: 9999;
  width: fit-content;
  height: auto;
  border: none;
  border-radius: 6px;
}
</style>
